"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var categoryFillColors = {
  W: 'fill-gray-300',
  G: 'fill-gray-300',
  R: 'fill-gray-300',
  S: 'fill-black',
  D: 'fill-yellow-500',
  F: 'fill-cyan-300',
  C: 'fill-green-500',
  DEFAULT: 'fill-purple-200'
};
var categoryOutsideColors = {
  W: 'fill-gray-400',
  G: 'fill-gray-400',
  R: 'fill-gray-400',
  S: 'fill-black',
  D: 'fill-yellow-600',
  F: 'fill-cyan-500',
  C: 'fill-green-500',
  DEFAULT: 'fill-purple-200'
};

var drivingIcon = function drivingIcon(iconColor) {
  return /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "22.81 15.08 22.81 4.12 31.94 9.6 22.81 15.08",
    className: iconColor
  });
};

var standingIcon = function standingIcon(iconColor) {
  return /*#__PURE__*/_react["default"].createElement("rect", {
    x: "20.98",
    y: "4.12",
    width: "10.96",
    height: "10.96",
    className: iconColor
  });
};

var RailCarTankParked = function RailCarTankParked(_ref) {
  var category = _ref.category,
      movementType = _ref.movementType,
      isEmpty = _ref.isEmpty,
      isParked = _ref.isParked,
      className = _ref.className;
  var assetCategory = Object.keys(categoryFillColors).some(function (key) {
    return key === category;
  }) ? category : 'DEFAULT';
  var fillColor = isEmpty ? 'fill-white' : categoryFillColors[assetCategory];
  var outsideColor = isEmpty ? categoryOutsideColors[assetCategory] : categoryFillColors[assetCategory];
  var movementIconColor = isEmpty ? categoryOutsideColors[assetCategory] : 'fill-white';
  var movementIcon;

  if (movementType === 'DRIVING') {
    movementIcon = drivingIcon(movementIconColor);
  }

  if (movementType === 'STANDING') {
    movementIcon = standingIcon(movementIconColor);
  }

  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "55.97",
    height: "24",
    viewBox: "0 0 55.97 24",
    className: className
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.22,17.41H48.53a3.34,3.34,0,0,0-.4-.35A8.21,8.21,0,0,0,44.71,1.39H40.88V.75A.75.75,0,0,0,40.14,0H35.82a.75.75,0,0,0-.74.75v.64H16.77V.75A.75.75,0,0,0,16,0H11.71A.76.76,0,0,0,11,.75v.64H8.22A8.21,8.21,0,0,0,4.79,17.06a3.25,3.25,0,0,0-.39.35H1.81a.78.78,0,0,0-.78.78v0a.76.76,0,0,0,.75.75H3.5a3.69,3.69,0,0,0-.18,1.11,3.91,3.91,0,1,0,7.08-2.28H12a3.91,3.91,0,1,0,7,3h15a3.91,3.91,0,1,0,7-3h1.58a3.87,3.87,0,0,0-.75,2.28,3.91,3.91,0,0,0,7.82,0A3.69,3.69,0,0,0,49.42,19h1.83a.75.75,0,0,0,.75-.75v0A.78.78,0,0,0,51.22,17.41Zm-44,5a2.35,2.35,0,1,1,2.35-2.35A2.35,2.35,0,0,1,7.23,22.44Zm7.92,0a2.35,2.35,0,1,1,2.35-2.35A2.35,2.35,0,0,1,15.15,22.44Zm20.27-2.35a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,35.42,20.09Zm7.92,0a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,43.34,20.09Z",
    className: fillColor
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.22,17.41H48.53a4.36,4.36,0,0,0-.4-.35A8.21,8.21,0,0,0,44.71,1.39H40.88V.75A.75.75,0,0,0,40.13,0H35.82a.76.76,0,0,0-.75.75v.64H16.77V.75A.76.76,0,0,0,16,0H11.71A.76.76,0,0,0,11,.75v.64H8.21A8.21,8.21,0,0,0,4.79,17.06a3.34,3.34,0,0,0-.4.35H1.81a.78.78,0,0,0-.78.78v0a.75.75,0,0,0,.75.75H3.5a3.69,3.69,0,0,0-.18,1.11,3.91,3.91,0,1,0,7.08-2.28H12a3.87,3.87,0,0,0-.75,2.28,3.91,3.91,0,0,0,7.75.7h15a3.91,3.91,0,0,0,7.75-.7,3.86,3.86,0,0,0-.74-2.28h1.58a3.91,3.91,0,1,0,7.08,2.28A3.69,3.69,0,0,0,49.42,19h1.83a.75.75,0,0,0,.75-.75v0A.78.78,0,0,0,51.22,17.41Zm-44,5a2.35,2.35,0,1,1,2.35-2.35A2.35,2.35,0,0,1,7.23,22.44Zm7.91,0a2.35,2.35,0,1,1,2.35-2.35A2.35,2.35,0,0,1,15.14,22.44Zm20.28-2.35a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,35.42,20.09ZM8.23,16.32h0A6.64,6.64,0,0,1,7,16.2H7a6.7,6.7,0,0,1-1-.27l-.21-.08a6.94,6.94,0,0,1-.83-.39l-.28-.17a6.76,6.76,0,0,1-.61-.44c-.13-.1-.25-.21-.37-.32s-.25-.24-.37-.37a5.85,5.85,0,0,1-.45-.54l-.27-.37-.27-.45c-.11-.2-.2-.41-.29-.62s-.13-.33-.19-.5-.1-.35-.14-.53-.09-.44-.12-.66A4.36,4.36,0,0,1,1.53,10c0-.12,0-.24,0-.36A6.74,6.74,0,0,1,8.23,2.88H44.71A6.74,6.74,0,0,1,51.42,9.6a6.62,6.62,0,0,1-.1,1.1c0,.05,0,.11,0,.16a7.56,7.56,0,0,1-.27,1A1.43,1.43,0,0,1,51,12a6.13,6.13,0,0,1-.41.86l-.12.2a7.27,7.27,0,0,1-.55.78l-.11.12a8.22,8.22,0,0,1-.66.66l-.1.09a5.89,5.89,0,0,1-.83.58l-.13.09a6.2,6.2,0,0,1-.94.44l-.11,0a6.26,6.26,0,0,1-1.07.3h0a6.67,6.67,0,0,1-1.19.11H8.23Zm35.11,3.77a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,43.34,20.09Z",
    className: outsideColor
  }), movementIcon, isParked && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M55.43,12.6H42.51a.56.56,0,0,1-.46-.23.42.42,0,0,1,0-.47L48.49.25a.59.59,0,0,1,1,0L55.91,11.9a.44.44,0,0,1,0,.47A.56.56,0,0,1,55.43,12.6Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49,9.2a.51.51,0,0,1-.54-.48V5.32a.54.54,0,0,1,1.08,0v3.4A.51.51,0,0,1,49,9.2Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49,9.69a.51.51,0,0,0-.54.48.54.54,0,0,0,1.08,0A.51.51,0,0,0,49,9.69Z",
    style: {
      fill: '#fff'
    }
  })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.13,0H42.39A.45.45,0,0,0,42,.43V12.12a.46.46,0,0,0,.42.47H54.08a.42.42,0,0,0,.42-.42V.43A.38.38,0,0,0,54.13,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.4,5.12a1.92,1.92,0,0,1-.63,1.55A2.74,2.74,0,0,1,48,7.2H47.4V9.43H46.08V3.17h2a2.66,2.66,0,0,1,1.73.49A1.8,1.8,0,0,1,50.4,5.12Zm-3,1h.44a1.42,1.42,0,0,0,.92-.25.84.84,0,0,0,.3-.7.87.87,0,0,0-.25-.69,1.19,1.19,0,0,0-.8-.22H47.4Z",
    style: {
      fill: '#fff'
    }
  })))));
};

RailCarTankParked.propTypes = {
  category: _propTypes["default"].string,
  movementType: _propTypes["default"].string.isRequired,
  isEmpty: _propTypes["default"].bool,
  isParked: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
RailCarTankParked.defaultProps = {
  category: 'DEFAULT',
  isEmpty: false,
  isParked: true,
  className: ''
};
var _default = RailCarTankParked;
exports["default"] = _default;